import ExplorAreaCard from "./explor-area-card";
import { ICPCreatorExplor, ServiceExplorType } from "@/types/global";

const Explor = ({
    title,
    service
}: {
    title: string;
    service: ICPCreatorExplor[] | ServiceExplorType[]
}) => {
    return (
        <>
            <section
                className="desilo-service6-section overflow-hidden"
                id="service-section"
            >
                <div className="container custom-container">
                    <div className="row gx-4 gy-5">
                        <div className="col-12 col-xl-5 col-xxl-6">
                            <div className="desilo__header text-left text-lg-start">
                                <h2 className="title">
                                    {title}
                                </h2>
                            </div>
                        </div>
                        <div className="col-12 row-padding-top mt-0">
                            <div className="row g-4">
                                {/* service card start */}
                                {service.map((item, i) => (
                                    <ExplorAreaCard
                                        key={i}
                                        data={item}
                                    />
                                ))}
                                {/* service card end */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Explor;
